// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Glint — tiny DOM helpers.

const ESC: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/** Escape user/peer-supplied text before it goes into innerHTML. */
export function escapeHtml(s: string): string {
  return String(s).replace(/[&<>"']/g, (c) => ESC[c]);
}

/** Format an integer score with thousands separators. */
export function fmtScore(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

/** mm:ss.d from milliseconds. */
export function fmtTime(ms: number): string {
  const t = Math.max(0, ms);
  const s = Math.floor(t / 1000);
  const d = Math.floor((t % 1000) / 100);
  return `${s}.${d}s`;
}
